import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { downloadService } from './download.service';

export const DownloadReportPage = () => {
  const { reportRequestId } = useParams();
  const navigate = useNavigate();

  React.useEffect(() => {
    const download = async () => {
      try {
        const { url } = await downloadService.getDownloadUrl(reportRequestId!);

        const anchor = document.createElement('a');
        anchor.href = url;
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
      } catch {
        // Silently handle errors — replicate old behavior
      } finally {
        navigate('/', { replace: true });
      }
    };

    download();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
